import React, { useEffect, useState, useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Card } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import { getPosSales } from "../../../../services/sales/posService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import SalesPosDetail from "./salesPosDetail";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
function SalesPOSList({ outletID }) {
  const { reload } = useGlobalData();
  const [salesPos, setSalesPos] = useState([]);
  const [salesPosID, setSalesPosID] = useState(0);
  const [openSalesReturnForm, setOpenSalesReturnForm] = useState(false);
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.now().startOf("month"),
    dateTo: DateTime.now().endOf("month"),
  });
  async function getPosSalesData(outletID = 0) {
    const response = await getPosSales(
      outletID,
      selectParam.dateFrom,
      selectParam.dateTo
    );
    const { data } = response.data;
    setSalesPos(data.salesPos);
  }

  useEffect(() => {
    getPosSalesData(outletID);
  }, [reload]);

  const salesPosDetailColumn = [
    {
      header: "Sales Agent",
      field: "salesName",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <div>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getPosSalesData(outletID);
              }}
            >
              <i className="fas fa-search"></i>
              Get POS Sales
            </button>
          </div>
        </div>
      </OverlayPanel>
      {salesPos.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesPos}
            dataDetailColumns={salesPosDetailColumn}
            onRefreshData={() => {
              getPosSalesData(outletID);
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "POS ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Person Responsible",
                field: "createdByName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.createdByName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Date",
                field: "salesDate",
                body: (rowData) => <>{formatDate(rowData.salesDate)}</>,
                sortable: true,
                filter: true,
              },
              {
                header: "Customer Name",
                field: "customer.customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customer.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Payment Method",
                field: "payMethodName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Grand Total",
                field: "total",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.total}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <BootstrapTooltip title="POS Sales Detail">
                    <button
                      type="button"
                      onClick={() => {
                        setSalesPosID(rowData.ID);
                        setOpenSalesReturnForm(true);
                      }}
                      className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-list-alt"></i>
                    </button>
                  </BootstrapTooltip>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description={`You don't have any POS Sales for current data selection!`}
            guidance={`Hint: Try to filter another date ranges to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSalesReturnForm}
        title="POS Sales Detail"
        onCloseDialog={() => {
          setOpenSalesReturnForm(false);
        }}
        minHeight={true}
      >
        <SalesPosDetail
          salesPosID={salesPosID}
          onCloseDialog={() => {
            setOpenSalesReturnForm(false);
          }}
        />
      </DialogLayout>
    </div>
  );
}

export default SalesPOSList;
